<template>
  <v-app class="app">
    <template v-if="isCearaAppRoute">
      <router-view />
    </template>
    <template v-else>

      <app-toolbar />

      <app-drawer />

      <v-main class="app-main-wrapper">

        <v-container class="pa-0" max-width="1070px">

          <app-banner />
          <page-header />

          <main class="app-main">
            <router-view />
          </main>

          <app-footer />

        </v-container>

      </v-main>

      <app-fab />
      <app-snack-bar />
      <app-snack-bar-content />

    </template>
  </v-app>
</template>

<script>
import Vue from "vue";
import AppFab from "@/components/AppFab";
import AppBanner from "@/components/AppBanner";
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import PageHeader from "@/components/PageHeader";
import AppSnackBar from "@/components/AppSnackBar";
import HasPrivilleges from "@/directives/privilleges";
import AppFooter from "@/components/AppFooter";
import Filters from "@/filters/global.filter";
import AppSnackBarContent from "@/components/AppSnackBarContent";

import MaskT from "@/directives/mask";
import VueCurrencyFilter from "vue-currency-filter";

Vue.use(VueCurrencyFilter, {
  symbol: "R$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true
});

export default Vue.extend({
  name: "App",
  metaInfo: {
    title: "Central de Serviços",
    titleTemplate: "%s | ARCE - Agência Reguladora do Ceará",
    meta: [{ vmid: "description", name: "description" }],
    htmlAttrs: { amp: true }
  },
  components: {
    AppFab,
    AppBanner,
    AppDrawer,
    AppFooter,
    PageHeader,
    AppToolbar,
    AppSnackBar,
    AppSnackBarContent
  },
  directives: { HasPrivilleges, MaskT },
  filters: { Filters },

  computed: {
    isCearaAppRoute() {
      return this.$route.meta.cearaApp;
    }
  },

  methods: {
    resizeRecaptcha() {
      this.$nextTick(() => {
        window.addEventListener("resize", this.getWindowWidth);
        this.getWindowWidth();
      });
    },
    getWindowWidth() {
      const reCaptchaWidth = 304;
      const form = document.getElementsByClassName("v-form")[0];
      if (!form) return;

      const containerWidth = form.clientWidth;
      if (reCaptchaWidth > containerWidth) {
        const scale = containerWidth / reCaptchaWidth;
        const recaptcha = document.getElementsByClassName("recaptcha")[0];
        if (recaptcha) recaptcha.style.transform = `scale(${scale})`;
      }
    }
  },

  mounted() {
    this.resizeRecaptcha();
  }
});
</script>

<style lang="scss">
@import "@/assets/styles/index.scss";

.app {
  background-color: #f5f5f5 !important;
}

.app-main-wrapper {
  padding-top: 16px;
}

.app-main {
  min-height: 590px;
}

.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}
</style>
